import React, { useCallback, useRef } from "react";
import { FlatList, ListRenderItem } from "react-native";
import { Tab } from "../ui/tab";
import { Id } from "@teachloop/backend/_generated/dataModel";

function LessonHistorySubjectList({
  lessonHistorySubjects,
  selectedSubjectId,
  setSelectedSubjectId,
}: {
  lessonHistorySubjects: { id: Id<"subjects">; label: string }[];
  selectedSubjectId: Id<"subjects"> | null;
  setSelectedSubjectId: (subjectId: Id<"subjects"> | null) => void;
}) {
  const tabBarRef = useRef<FlatList>(null);

  const renderItem: ListRenderItem<{ id: Id<"subjects">; label: string }> =
    useCallback(
      ({ item, index }) => (
        <Tab
          onPress={() => {
            setSelectedSubjectId?.(item.id);
            setTimeout(() => {
              tabBarRef.current?.scrollToIndex({
                index,
                animated: true,
              });
            }, 100);
          }}
          intent={item.id === selectedSubjectId ? "active" : undefined}
        >
          <Tab.Text>{item.label}</Tab.Text>
        </Tab>
      ),
      [setSelectedSubjectId, selectedSubjectId]
    );

  return (
    <FlatList
      ref={tabBarRef}
      horizontal
      showsHorizontalScrollIndicator={false}
      data={lessonHistorySubjects}
      contentContainerClassName="gap-4"
      renderItem={renderItem}
    />
  );
}

export default LessonHistorySubjectList;
